import { Action } from 'store/store';

export enum AlgorithmParametersRevisionIndexActionType {
    ALGORITHM_PARAMETERS_SET_REVISION_INDEX = 'ALGORITHM_PARAMETERS_SET_REVISION_INDEX',
    ALGORITHM_PARAMETERS_INCREMENT_REVISION_INDEX = 'ALGORITHM_PARAMETERS_INCREMENT_REVISION_INDEX',
    ALGORITHM_PARAMETERS_DECREMENT_REVISION_INDEX = 'ALGORITHM_PARAMETERS_DECREMENT_REVISION_INDEX',
}

export interface AlgorithmParametersSetRevisionIndexPayload {
    revisionIndex: number;
}

export type AlgorithmParametersSetRevisionIndex = Action<
    AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_SET_REVISION_INDEX,
    AlgorithmParametersSetRevisionIndexPayload
>;

export function setRevisionIndexAction(
    revisionIndex: number
): AlgorithmParametersSetRevisionIndex {
    return {
        type: AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_SET_REVISION_INDEX,
        payload: {
            revisionIndex,
        },
    };
}

export type AlgorithmParametersIncrementRevisionIndex =
    Action<AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_INCREMENT_REVISION_INDEX>;

export function incrementRevisionIndexAction(): AlgorithmParametersIncrementRevisionIndex {
    return {
        type: AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_INCREMENT_REVISION_INDEX,
    };
}

export type AlgorithmParametersDecrementRevisionIndex =
    Action<AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_DECREMENT_REVISION_INDEX>;

export function decrementRevisionIndexAction(): AlgorithmParametersDecrementRevisionIndex {
    return {
        type: AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_DECREMENT_REVISION_INDEX,
    };
}

export type AlgorithmParametersRevisionIndexAction =
    | AlgorithmParametersSetRevisionIndex
    | AlgorithmParametersIncrementRevisionIndex
    | AlgorithmParametersDecrementRevisionIndex;
